import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';
import { CaptureInvoiceLineItemImport } from '../models/capture-invoice-line-item-import.model';
import { LimitOffsetPagingMeta } from '../models/paged-results/limit-offset-paging.model';
import { PagedResults } from '../models/paged-results/paged-results.model';

export class PagedCaptureInvoiceLineItemImports implements PagedResults {
  captureInvoiceLineItemImports: CaptureInvoiceLineItemImport[];
  meta: LimitOffsetPagingMeta;

  get records() {
    return this.captureInvoiceLineItemImports;
  }
}

@Injectable()
export class CaptureInvoiceLineItemImportsService extends ApiService {
  private http = inject(HttpClient);


  get(id): Observable<CaptureInvoiceLineItemImport> {
    return this.http.get<CaptureInvoiceLineItemImport>(
      `${environment.captureApi.url}/capture_invoice_line_item_imports/${id}`
    );
  }

  getList(
    paging: { page: number; pageSize: number } = null,
  ): Observable<PagedCaptureInvoiceLineItemImports> {
    const params = new URLSearchParams();

    if (paging) {
      params.append('page', paging.page.toString());
      params.append('per_page', paging.pageSize.toString());
    }

    return this.http.get<PagedCaptureInvoiceLineItemImports>(
      `${environment.captureApi.url}/capture_invoice_line_item_imports?${params.toString()}`
    );
  }

  create(signedId: string): Observable<CaptureInvoiceLineItemImport> {
    return this.http.post<CaptureInvoiceLineItemImport>(
      `${environment.captureApi.url}/capture_invoice_line_item_imports`,
      {
        captureInvoiceLineItemImport: { signedId },
      }
    );
  }

  cancel(id): Observable<CaptureInvoiceLineItemImport> {
    return this.http.patch<CaptureInvoiceLineItemImport>(
      `${environment.captureApi.url}/capture_invoice_line_item_imports/${id}/cancel`,
      {}
    );
  }
}
